import { Controller } from "@hotwired/stimulus"

// A petty cash receipt's expense area decides what else it needs: a project or
// job card for project/workshop receipts, a division for General ones, and
// nothing for Head Office (which IS a division). Show only the field that
// applies, so the form never asks a question whose answer is ignored.
export default class extends Controller {
  static targets = ["scope", "costCenterField", "divisionField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const scope = this.scopeTarget.value
    const needsJob = ["project", "workshop"].includes(scope)

    this.show(this.costCenterFieldTarget, needsJob)
    this.show(this.divisionFieldTarget, scope === "general")
  }

  // A hidden field is also DISABLED, so it is not submitted: a project left
  // selected must not ride along on a General receipt (the database refuses).
  show(field, visible) {
    field.classList.toggle("hidden", !visible)
    field.querySelectorAll("select, input").forEach((input) => { input.disabled = !visible })
  }
}
